import { Nullable } from "@shared/models/general";
import { ListOptionBase } from "@shared/components";
import { DocumentStatusId } from "@documents/models/filter.models";

export const getDocumentsActionFlag = (status: Nullable<ListOptionBase>) => {
  switch (status?.id) {
    case DocumentStatusId.ActionItems:
    case DocumentStatusId.UnreadActionItems:
      return true;
    default:
      return null;
  }
};
